var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "btncsv",
      attrs: { flat: "", small: "", color: "primary" },
      on: {
        click: function($event) {
          return _vm.exportar("csv")
        }
      }
    },
    [
      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
        _vm._v("cloud_download")
      ]),
      _vm._v("  \n  "),
      _c("span", { staticClass: "importExportBtnTexto" }, [
        _vm._v("Exportar"),
        _c("br"),
        _vm._v("CSV")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }